import React from "react";

const BackendDataContext = React.createContext()

export default BackendDataContext;